import _BaseAPIService from "../_BaseAPIService";

const apiService = _BaseAPIService.instance;

const TestimonialService = {
    create:async(data) => {
        try {
        // Check token before request
        const userString = localStorage.getItem("user");
        const user = JSON.parse(userString);
        console.log("Token being used:", user?.accessToken ? "EXISTS" : "MISSING");
        
        const response = await apiService.post("/testimonials", data);
        return response.data;
    } catch(error) {
        console.log("Error creating Testimonial", error);
        console.log("Error status:", error.response?.status);
        console.log("Error data:", error.response?.data);
        throw error;
    }
    },

    getList:async() => {
        try{
            const response = await apiService.get("/testimonials");
            return response.data;
        }catch(error){
            console.log("Error Fetching Testimonials");
            throw error;
        }
    },

    getDetail:async(id) => {
        const response = await apiService.get(`/testimonials/${id}`);
        console.log("called");
        return response.data;
    },

    update:async (id,updateData) => {
        try{
            const response = await apiService.put(`/testimonials/${id}`,updateData);
            return response.data;
        }catch(error){
            console.error("Error updating testimonial",error);
            throw error;
        }
    },
    delete:async (id) => {
        const response = await apiService.delete(`/testimonials/${id}`);
        return response.data;
    },



};

export default TestimonialService;